import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=393e7fb3&"
import script from "./AppHeader.js?vue&type=script&lang=js&"
export * from "./AppHeader.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports